import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importDashboardContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "DashboardContainer" */
                '@perpay-web/fintech/components/containers/DashboardV2Container'
            ),
    );
